import * as _ from "lodash";
import http from "../constant/api";

export const noteService = {
  listNoteByMessageId: async (messageId) => {
    const result = await http.get(`/api/note/message-id/${messageId}/list`);

    return result;
  },
  queryNoteBySessionId: async (sessionId, filter) => {
    const result = await http.get(`/api/note/session-id/${sessionId}/query`, {
      params: filter,
    });

    return result;
  },
  addNote: async (data) => {
    const result = await http.post(`/api/note/add`, data);

    return result;
  },
  editNote: async (id, data) => {
    const result = await http.put(`/api/note/${id}/edit`, data);

    return result;
  },
  removeNote: async (id) => {
    const result = await http.delete(`/api/note/${id}/remove`);

    return result;
  },
};
